import React from "react";
import { Link } from "react-router-dom";
import { FooterLogo, Logo } from "../constant/Index";
import { useSiteContentQuery } from "../store/services/SitesettingService";

const Footer = () => {
	const { data, isLoading } = useSiteContentQuery();
	let response = data?.response?.data[0];
	return (
		<>
			{/* Footer Sec Start Here */}
			<footer>
				<div className="container">
					<div className="row align-items-center">
						<div className="col-lg-8">
							<div className="row align-items-center frst-row">
								<div className="col-lg-6">
									<div className="row">
										<div className="col-lg-6">
											<ul className="info">
												<li>
													<a href={"mailto:" + response?.contact_email}>
														{response?.contact_email}
													</a>
												</li>
												<li>
													<a href={"tel:" + response?.contact_phone}>
														{response?.contact_phone}
													</a>
												</li>
											</ul>
										</div>
										<div className="col-lg-6">
											<ul className="info">
												<li>{response?.address}</li>
											</ul>
										</div>
									</div>
								</div>
								<div className="col-lg-6">
									<div className="footer-logo">
										<Link to="/">
											<figure>
												<img
													src={response?.logo_path}
													alt=""
													className="img-fluid"
												/>
											</figure>
										</Link>
									</div>
								</div>
							</div>
						</div>
						<div className="col-lg-4">
							<ul className="social-links">
								<li>
									<a target="_blank" href={response?.facebook}>
										Facebook
									</a>
								</li>
								<li>
									<a target="_blank" href={response?.twitter}>
										Twitter
									</a>
								</li>
								<li>
									<a target="_blank" href={response?.vimeo}>
										Vimeo
									</a>
								</li>
								<li>
									<a target="_blank" href={response?.instagram}>
										Instagram
									</a>
								</li>
								<li>
									<a target="_blank" href={response?.google}>
										Google+
									</a>
								</li>
								<li>
									<a target="_blank" href={response?.youtube}>
										Youtube
									</a>
								</li>
							</ul>
						</div>
					</div>
				</div>
				<div className="copyright">
					<p>{response?.copyright}</p>
				</div>
			</footer>
			{/* Footer Sec End Here */}
		</>
	);
};

export default Footer;
